import { createTheme } from "@mui/material";
import { rootTheme } from "../../utils/theme";

export const theme = createTheme({
  
  typography: {
    allVariants: {
      color: "#F8FAFF",
    },
    ...rootTheme.typography,
  },
  components: {
  
    MuiIconButton: {
      styleOverrides: {
        root: {
          background: "rgba(0, 136, 245, 0.15)",
          color: "#F8FAFF",
        },
      },
    },
    // MuiListItem: {
    //   styleOverrides: {
    //     root: {
    //       cursor: 'pointer'
    //     }
    //   }
    // },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: 16,
          fontWeight: 700,
          color: "#F8FAFF",
        },
        secondary: {
          fontSize: 12,
          fontWeight: 400,
          color: "#F8FAFF",
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        container: {
          marginLeft: 5,
          marginRight: 5,
          listStyle: 'none'
        },
        root: {
          cursor: "pointer",
          backgroundColor: "rgba(0, 136, 245, 0.15)",
          color: "#F8FAFF",
          borderRadius: 8,
          minHeight: 75,
          marginTop: 10,
          "&.Mui-disabled": {
            color: "#D4D4D8",
            background: "rgba(0, 136, 245, 0.15)",
            opacity: 0.4,
          },
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 0,
          marginTop: 30,
          marginBottom: 20,
          color: "#0088F5",
          backgroundColor: "#0088F5",
        },
      },
    },
  },
});


export const styles = {
  icon: {
    width: 20,
    height: 20
  }
}